import React from 'react';

const TripCancellationCFStepShared = () => (
  <ol>
    <li>
      Copies of cancelled checks or credit card statements that shows all payments made for the trip with an invoice from your
      Travel Provider showing the total cost paid for the trip
    </li>
    <li>
    Airline Ticket Stub/Receipt
    Note: Copies of new airline tickets purchased due to interruption (if applicable) along with documentation of the cost incurred. Please forward the original airline tickets if applicable.
    </li>
    <li>
    Police Report (if applicable).
    </li>
    <li>
    Car Rental Agreement (if applicable).
    </li>
    <li>
      Copies of reimbursement statements issued by an airline carrier, airport facility, car rental agency, travel agent, hotel/motel
      or other similar establishment or any other insurance company providing reimbursement to you for the loss.
    </li>
  </ol>
);

export default TripCancellationCFStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.TripCancellationStep/components/TripInterruptionCFStepShared.js